import { SyntheticEvent } from "react";

export interface IGWidget {
    id?:string;
    className?:string;
}

export function appendClass(className:string, other:string[]|string|undefined) {
    if (!other) return className
    else if (other instanceof Array){
        let ret:string = className || ""
        for(const klass of other){
            if (klass) ret = (ret ? ret+" " : "") + klass
        }
        return ret
    }
    else return className ? className + " " + other : other;
}

export function addClass(className:string, props:IGWidget) {
    return appendClass(className, props.className)
}

export type TMouseEvent = (e:SyntheticEvent)=>void;
